import React from 'react';
import Spinner from 'common/components/Spinner';
import { useTranslation } from 'services/localization/useTranslation';
import { useSelector } from 'react-redux';
import * as InventorySelectors from 'selectors/InventorySelectors';
import * as ShopSelectors from 'selectors/ShopSelectors';
import AddArticles from './AddArticles';
import SetPageNavAction from 'components/Portals/SetPageNavAction';
import { replace, Routes } from 'routing';
import EmptyState from 'common/components/EmptyState';
import SetPageTitle from 'components/Portals/SetPageTitle';
import { emptyInventoryFields } from 'common/modules/inventory';

const AddArticlesWrapper = () => {
	const { t } = useTranslation();
	const skuItems = useSelector(InventorySelectors.skuItems);
	const inventoryConfiguration = useSelector(InventorySelectors.inventoryConfiguration);
	const shopId = useSelector(ShopSelectors.activeShopId)!;

	if (!!skuItems.loading || !!inventoryConfiguration.loading) {
		return <Spinner />;
	}

	return (
		<>
			<SetPageNavAction
				priority={2}
				backAction={{ to: Routes.INVENTORY, title: t('inventory.inventory', 'Inventory') }}
			/>
			<SetPageTitle priority={2} title={t('inventory.addArticles.pageTitle', 'Add articles')} />
			<EmptyState
				title={t('inventory.addArticles.emptyState', 'Issue loading inventory articles')}
				isLoading={!!skuItems.loading || !!inventoryConfiguration.loading}
				isEmpty={!skuItems.data}
				callToActionText={t('common:actions.goBack')}
				callToActionHandler={() => replace(Routes.INVENTORY)}
				render={() => (
					<AddArticles
						skuItems={skuItems.data ?? []}
						inventoryFields={inventoryConfiguration.data?.fields ?? emptyInventoryFields()}
						shopId={shopId}
					/>
				)}
			/>
		</>
	);
};

export default AddArticlesWrapper;
